<template>
	<div class="memoCreateButton" @click="supportLogCreateModalOpen">
		<i class="fa-solid fa-plus fa-fw mr-2" />応対履歴の追加
	</div>
</template>
<script setup>
import { onMounted } from "vue";

/* ---------------------------------------------------------------------------
emit
---------------------------------------------------------------------------- */
const emit = defineEmits(["supportLogCreateModalOpen"]);

function supportLogCreateModalOpen() {
	emit("supportLogCreateModalOpen");
}

onMounted(() => {});
</script>
<style scoped lang="scss">
@use "/resources/css/_adjust.scss" as *;

.memoCreateButton {
	cursor: pointer;
	font-size: 1.6rem;
	text-align: center;
	padding: 15px 20px;
	border-radius: 5px;
	border: 3px dashed $bg-gray3;
	// position: sticky;
	width: 100%;
	// top: 100px;
	@include trans(0.3);
	&:hover {
		color: $color-white2;
		background: $bg-blue2;
		border-color: $bg-blue2;
		@include trans(0.3);
	}
}
</style>
